import { Button } from "@src/components/Button";

import { constants } from "./constants";
import "./style.less";

export function LinkChanger() {
  return (
    <div className="LinkChanger-component">
      <Button
        onClick={() => {
          const link = window.location.href
            .replace(
              window.location.host,
              constants.linkBeingUsed === "recommended"
                ? "meuplay.fabriccamultimidia.com"
                : "fabricca.pro",
            )
            .replace("http://", "https://");
          console.log("[LinkChanger] indo para:", link);
          window.location.href = link;
        }}
        small
        white
      >
        {constants.linkText}
      </Button>
    </div>
  );
}
